import React, { useEffect, useState } from 'react';
import { AdjuntosAdapter } from '../../../../../infraestructure/persistence/rest/AdjuntosAdapter';
import { ServerErrorMessage } from '../../../../../shared/utils/error';
import { useNotifications } from '../../../../../shared/hooks/Notifications';

export const useApiTiposAdjunto = () => {
	
	const apiAdjuntos = new AdjuntosAdapter();
	const { exceptionError, resultError } = useNotifications();
	let result: any;
  
  	useEffect(()=>{
    	getTiposAdjunto();
	},[])

	const getTiposAdjunto = async () => {
		try {
			result = await apiAdjuntos.ListarTiposAdjunto();
			if(result.data && result.data!=="")
			{
                return [ ...result.data ] || []
				//setTipos([ ...result.data ] || []);
			}else{resultError()}
		} catch (error) {
			let exception = ServerErrorMessage(error);
			exceptionError(exception);
            return []
		}
	};

    const api = {
        api:{
        getTiposAdjunto
        }
    }

    return {...api};
};